import React from 'react';
import Link from '@amzn/awsui-components-react-v3/polaris/link';

const externalLinkProps = {
    external: true,
    externalIconAriaLabel: 'Opens in a new tab'
};

export const ExternalLinkItem = ({ href, text }) => (
    <Link href={href} {...externalLinkProps} ariaLabel={`${text} ${externalLinkProps.externalIconAriaLabel}`} target="_blank">
        {text}
    </Link>
);